import optionGroupStyles from '~/styles/option-group.module.css';

type Props = {
  name?: string;
  children: React.ReactNode;
};

export default function OptionGroup({
  name,
  children,
}: Props) {
  return (
    <div>
      {name && (
        <h3 className={optionGroupStyles.optionGroupHeading}>
          {name}
        </h3>
      )}

      <div className={optionGroupStyles.optionGroupOptions}>
        {children}
      </div>
    </div>
  );
}
